var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 116,
    viewBox: "0 0 167 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3645 1.86087L4.84573 27.0648C3.47762 27.5492 2.29322 28.4455 1.45536 29.6306C0.617501 30.8156 0.167334 32.2311 0.16685 33.6825L0.14082 108.346C0.139894 109.468 0.407815 110.574 0.92208 111.571C1.43634 112.568 2.18213 113.428 3.09677 114.077C4.01142 114.727 5.06837 115.148 6.17921 115.306C7.29005 115.463 8.42244 115.352 9.48149 114.981L76.3989 91.5955C80.1558 90.2771 84.2403 90.2858 88.0058 91.5955L154.561 114.955C155.621 115.327 156.754 115.44 157.866 115.284C158.978 115.127 160.036 114.706 160.952 114.056C161.868 113.406 162.615 112.546 163.129 111.548C163.644 110.55 163.912 109.444 163.911 108.321L163.867 33.5532C163.867 30.5718 161.989 27.9265 159.18 26.9356L88.0316 1.86087C84.2574 0.52528 80.1386 0.52528 76.3645 1.86087Z",
    fill: "#175583"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.824 100.385L166.375 101.332L164.824 100.385Z",
    fill: "#B22E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.ebc53fd7554522663889817dbac3d376.svg";
export { ForwardRef as ReactComponent };